/** Detektuje izvor streama za odabir odgovarajućeg metadata API-ja */

const AZURACAST_URL = import.meta.env.VITE_AZURACAST_URL || '';

export function isAzuraCastStream(streamUrl: string): boolean {
  if (!AZURACAST_URL) return false;
  try {
    const base = AZURACAST_URL.replace(/\/$/, '');
    return streamUrl.startsWith(base) || streamUrl.includes(new URL(base).hostname);
  } catch {
    return false;
  }
}

export function getAzuraCastStationShortcode(streamUrl: string): string | null {
  if (!isAzuraCastStream(streamUrl)) return null;
  // URL format: https://radio.example.com/listen/station_shortcode/radio.mp3
  const match = streamUrl.match(/\/listen\/([^/]+)\//);
  return match ? match[1] : null;
}
